import { Component, OnInit, TemplateRef, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TourService } from 'ngx-tour-ngx-bootstrap';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @ViewChild('mysidebar') mysidebar: ElementRef;
  selectedLanguage = null;
  user = this.apiService.user;
  url = this.apiService.url + '/uploads/';
  logo = localStorage.getItem('lungLogo');
  tour = false;
  constructor(
    private modalService: BsModalService,
    private router: Router,
    public tourService: TourService,
    private renderer: Renderer2,
    public translations: TranslationService,
    public apiService: ApiService
  ) {

    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.mysidebar.nativeElement.contains(e.target)) {
        if (window.screen.width <= 990 && this.apiService.sidebar) {
          this.hideSidebar();
        }
      }
    });

    this.tourService.start$.subscribe(() => {
      this.tour = true;
    });
    this.tourService.end$.subscribe(() => {
      this.tour = false;
    });
  }

  ngOnInit() {
    this.apiService.getClient().subscribe((res: any) => {
      if (res.data.logo) {
        this.logo = res.data.logo;
      } else {
        this.logo = 'assets/images/logo.png';
      }
      localStorage.setItem('lungLogo', this.logo);
    }, err => {
      this.logo = 'assets/images/logo.png';
      localStorage.setItem('lungLogo', this.logo);
    });
  }

  modalRef: BsModalRef;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'tour-modal' });
  }
  closeModal() {
    this.modalRef.hide();
    setTimeout(() => {
      this.tourService.start();
      this.renderer.addClass(document.body, 'overlay');
    }, 1000);
  }

  hideSidebar() {
    this.apiService.setSidebar();
    this.renderer.addClass(document.body, 'sidebar-hidden');
    this.renderer.removeClass(document.body, 'sidebar-show');
  }

  getSelectedlanguage() {
    if (this.selectedLanguage !== null) {
      return this.selectedLanguage;
    } else {
      if (this.translations.languages.length > 0) {
        return this.translations.languages[0].title;
      } else {
        return null
      }
    }
  }

  changelanguage(lang) {
    this.selectedLanguage = lang.title;
    this.translations.getTranslations(lang._id);
  }

  resetUserData() {
    var result = confirm("Are you sure you want to reset your profile?");
    if (result) {
      this.apiService.resetUserData().subscribe(data => {
        this.router.navigate(['/questions-answer']);
      });
    }
  }

  logout() {
    localStorage.removeItem('lunge_front');
    this.router.navigate(['/login']);
  }

}
